import React from "react"

import { parse } from "node-html-parser"

import * as tM1FunctionDisplayStyles from "../styles/TM1FunctionDisplay.module.css"

export default function TM1FunctionDisplay(props) {
  const { content } = props

  const htmlContent = parse(content.replace(/[\r\n]/gm, `<br/>`))

  let textCounter = 0
  const elems =
    htmlContent.childNodes &&
    htmlContent.childNodes.map((el, idx) => {
      if (el.tagName) {
        return el
      }

      textCounter++
      if (textCounter === 1) return parse(`<h2>${el.text}</h2>`)
      if (textCounter === 2) return parse(`<h3>${el.text}</h3>`)

      return el
    }).filter(el => !el.tagName || el.tagName.toLowerCase() !== `br`)

  return (
    <div className={`row ${tM1FunctionDisplayStyles.wrapper}`}>
      <div className={`col-12 ${tM1FunctionDisplayStyles.group}`}>
        {elems &&
          elems.map((el, idx) => (
            <div
              key={idx}
              className={`row ${tM1FunctionDisplayStyles.innerWrapper}`}
            >
              <div
                className={`col-12`}
                dangerouslySetInnerHTML={{ __html: el }}
              />
            </div>
          ))}
      </div>
    </div>
  )
}
